import { act_com } from '@lc/action/cardType/Common';
import { GameState } from '@lc/interface/gameState/types';
import { act_player } from '@lc/interface/player/action';
import { getPlayerStateWithId } from '@lc/lib/player_helper';

export class EventAction {
	// `IF NEITHER NEIGHBOR HAS A CHARGED BATTERY, RECHARGE TWO (2) BATTERIES WITH THE COLOR ENERGY OF YOUR NEIGHBORS`,
	carbonDating(playerData: any, gameState: GameState) {
		const players = gameState.playerStateArray;

		const neighborArr = act_com.createNeighborIdArray(playerData, players);
		const lState = players[neighborArr[0]];
		const pState = players[neighborArr[1]];
		const rState = players[neighborArr[2]];

		if (
			lState.batteryEnergyArr.length > 0 ||
			rState.batteryEnergyArr.length > 0
		) {
			return false;
		}

		act_player.refillBattery(pState, lState.energyColor);
		act_player.refillBattery(pState, rState.energyColor);

		return true;
	}

	contributionMatching(playerData: any, gameState: GameState) {
		console.log('contribution matching here we go');
		const { playerId, sourceId, targetId } = playerData;
		const players = gameState.playerStateArray;
		const neighborIds = act_com.getNeighborPlayerIds(
			playerId,
			players
		) as any;

		const pState = getPlayerStateWithId(players, playerId);
		const tState = getPlayerStateWithId(players, targetId);

		if (!neighborIds.includes(targetId)) return false;

		act_com.rechargeBatteryWithEnergyColorForPlayerId(
			playerId,
			gameState,
			tState.energyColor
		);
		act_com.rechargeBatteryWithEnergyColorForPlayerId(
			targetId,
			gameState,
			pState.energyColor
		);
		return true;
	}

	eminentDomain() {}

	fizzyDizzy(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		const carbonToSteal = Math.min(tState.carbonFootprint, 2);
		tState.carbonFootprint -= carbonToSteal;
		pState.carbonReserve += carbonToSteal;

		return true;
	}

	forceDonation(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		const donoArr: any = [];

		const neighborIds = act_com.getNeighborPlayerIds(
			playerId,
			gameState.playerStateArray
		);

		console.log('Testing neighbor functionality');
		console.log('playerId: ' + playerId);
		console.log('targetId: ' + targetId);
		console.log(neighborIds);

		if (!neighborIds.includes(targetId)) {
			console.log(
				'Tried to force donation on an opponent that wasnt a neighbor'
			);
			return false;
		}
		// I want energy, up to 2. Try to get both from factory, then battery, donate what's available

		// TODO whenever energy is reworked, this can come from any color + factory or battery
		while (donoArr.length < 2) {
			if (tState.factoryEnergyArr.length > 0) {
				donoArr.push(tState.factoryEnergyArr.pop());
			} else break;
		}

		while (donoArr.length < 2) {
			if (tState.batteryEnergyArr.length > 0) {
				donoArr.push(tState.batteryEnergyArr.pop());
			} else break;
		}

		if (donoArr.length === 0) {
			return false;
		}

		while (donoArr.length > 0) {
			tState.donationCupArr.push(donoArr.pop());
		}

		return true;
	}

	garageSale(playerData: any, gameState: GameState) {
		const { playerId, decisionId, numBatteries } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		let batteriesToDiscard = Math.min(numBatteries, 2);

		if (decisionId === 0) {
			while (batteriesToDiscard > 0) {
				act_player.deleteBattery(pState);
				act_player.donateSingleEnergy(pState);
				batteriesToDiscard--;
			}
			return true;
		} else {
			let batteryPayment = act_player.stealEnergy(pState).length;

			if (batteryPayment === 0) {
				if (pState.carbonReserve > 0) {
					pState.carbonReserve -= 1;
					pState.carbonFootprint += 1;
					batteryPayment = 1;
				}
			}

			if (batteryPayment === 1) {
				act_player.buyBattery(pState);
				return true;
			}
		}
		return false;
	}

	hacktivist(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		for (let z = tState.prArr.length - 1; z >= 0; z--) {
			if (tState.prArr[z] !== tState.energyColor) {
				const mismatchedPR = tState.prArr.splice(z, 1);
				pState.prArr.push(mismatchedPR[0]);
			}
		}

		return true;
	}

	heDidIt(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		if (pState.prArr.length > tState.prArr.length) {
			pState.carbonFootprint -= 1;
			tState.carbonFootprint += 1;
		} else {
			return false;
		}

		return true;
	}

	investigativeJournalism(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const players = gameState.playerStateArray;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		const neighborIds = act_com.getNeighborPlayerIds(
			playerId,
			players
		) as any;
		if (!neighborIds.includes(targetId)) return false;

		if (tState.carbonFootprint > pState.carbonFootprint) {
			const targetPr = [...tState.prArr];
			tState.prArr = pState.prArr;
			pState.prArr = targetPr;
		}
		return true;
	}

	karma(playerData: any, gameState: GameState) {
		const { playerId, targetId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const tState = getPlayerStateWithId(
			gameState.playerStateArray,
			targetId
		);

		if (tState.equipment.length > 0) {
			const equippy = tState.equipment.pop();
			if (equippy) pState.equipment.push();
			return true;
		} else if (tState.batteries > 0) {
			tState.batteries--;
			act_player.buyBattery(pState);
			if (tState.batteryEnergyArr.length > tState.batteries) {
				const batteryEng = tState.batteryEnergyArr.pop();
				if (batteryEng) pState.batteryEnergyArr.push(batteryEng);
			}
			return true;
		} else if (tState.factories > 0) {
			tState.factories--;
			pState.factories++;
			if (tState.factoryEnergyArr.length > tState.factories) {
				const factoryEng = tState.factoryEnergyArr.pop();
				if (factoryEng) pState.factoryEnergyArr.push(factoryEng);
			}
			return true;
		}

		return false;
	}

	overcharge(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const players = gameState.playerStateArray;
		const pState = getPlayerStateWithId(players, playerId);

		act_com.rechargeBattery(playerData, gameState);
		act_com.rechargeBattery(playerData, gameState);

		const neighborIds = act_com.getNeighborPlayerIds(
			playerId,
			players
		) as any;

		act_com.rechargeBatteryWithEnergyColorForPlayerId(
			neighborIds[0],
			gameState,
			pState.energyColor
		);
		act_com.rechargeBatteryWithEnergyColorForPlayerId(
			neighborIds[1],
			gameState,
			pState.energyColor
		);

		return true;
	}

	rivalSocial(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);
		const players = gameState.playerStateArray;

		const neighborIds = act_com.getNeighborPlayerIds(
			playerId,
			players
		) as any;
		for (let i = 0; i < neighborIds.length; i++) {
			const nId = neighborIds[i];
			pState.prArr.push(players[nId].energyColor);
		}

		return true;
	}

	spareCalculatorBatteries(playerData: any, gameState: GameState) {
		const { playerId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		const numEnergy = Math.floor(pState.factories / 2);
		for (let i = 0; i < numEnergy; i++) {
			act_com.rechargeBattery(playerData, gameState);
		}
		return true;
	}
}

export const act_event = new EventAction();
